module.exports = __webpack_public_path__ + "static/media/email.2f1e1bb7.svg";